<div class="cancel-container">
	<div class="body">
		<em (click)="closeModal()" class="k-icon k-i-close close"></em>
		<p class="title"></p>
		<p class="sub-title">
			This Gmail account is already used in another Shakespeare account. Please try another Gmail or contact your account manager.
		</p>
	</div>
</div>
